export const NEWS_TAG_TAGS = {
    NEWS_TAGS: "GetAllNewsTags",
} as const;